import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Phone, Mail, MapPin, MessageCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { clinicInfo } from '../../mock';
import { crisisResources } from '../../enhancedMock';
import { toast } from 'sonner';

export const Footer = ({ scrollToSection }) => {
  const navigate = useNavigate();
  return (
  <>
    <footer data-testid="site-footer" className="bg-darkBrown text-white py-8 md:py-12 px-4 relative z-10">
      <div className="container mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mb-8">
          <div className="col-span-2 md:col-span-1">
            <img
              src={clinicInfo.logo}
              alt="FAVOR HCS Logo"
              className="h-14 md:h-20 w-auto mb-3 md:mb-4 bg-white p-1.5 md:p-2 rounded-lg"
            />
            <p className="text-gray-300 text-xs md:text-sm">{clinicInfo.tagline}</p>
          </div>
          <div>
            <h3 className="font-bold text-sm md:text-lg mb-3 md:mb-4 text-primaryOrange">Quick Links</h3>
            <ul className="space-y-1.5 md:space-y-2 text-xs md:text-sm">
              {['home', 'about', 'services', 'insurance'].map((section) => (
                <li key={section}>
                  <button onClick={() => scrollToSection(section)} className="hover:text-primaryOrange transition-colors capitalize">
                    {section === 'about' ? 'About Us' : section}
                  </button>
                </li>
              ))}
              <li><button onClick={() => navigate('/intake')} className="hover:text-primaryOrange transition-colors">New Patient Intake</button></li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold text-sm md:text-lg mb-3 md:mb-4 text-primaryOrange">Services</h3>
            <ul className="space-y-1.5 md:space-y-2 text-xs md:text-sm text-gray-300">
              <li>ADD/ADHD Treatment</li>
              <li>Depression Care</li>
              <li>Anxiety Management</li>
              <li>PTSD Therapy</li>
              <li>Child & Adolescent</li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold text-sm md:text-lg mb-3 md:mb-4 text-primaryOrange">Contact Info</h3>
            <ul className="space-y-2 md:space-y-3 text-xs md:text-sm">
              <li className="flex items-start space-x-2">
                <MapPin size={14} className="mt-0.5 flex-shrink-0" />
                <span className="text-gray-300">{clinicInfo.address}</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone size={14} className="flex-shrink-0" />
                <span className="text-gray-300">{clinicInfo.phone}</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone size={14} className="flex-shrink-0" />
                <span className="text-gray-300">Fax: {clinicInfo.fax}</span>
              </li>
              <li className="flex items-center space-x-2">
                <Mail size={14} className="flex-shrink-0" />
                <span className="text-gray-300 text-[10px] md:text-xs">{clinicInfo.email}</span>
              </li>
            </ul>
          </div>
        </div>

          <div className="border-t border-gray-700 pt-6 md:pt-8 mb-6 md:mb-8">
          <h3 className="font-bold text-base md:text-xl mb-3 md:mb-4 text-center text-primaryOrange">Crisis Resources - Available 24/7</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
            {crisisResources.map((resource) => (
              <div key={resource.title} className={`text-center p-3 md:p-4 rounded-lg ${resource.urgent ? 'bg-red-600/20 border-2 border-red-500' : 'bg-white/5'}`}>
                <p className="font-bold text-white mb-1 text-xs md:text-sm">{resource.title}</p>
                <p className="text-lg md:text-2xl font-bold text-primaryOrange mb-1">{resource.phone}</p>
                <p className="text-[10px] md:text-xs text-gray-300">{resource.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-gray-700 pt-6 md:pt-8 text-center text-xs md:text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} FAVOR HCS. All rights reserved. | Compassionate Care for Mental Wellness</p>
        </div>
      </div>
    </footer>

    {/* Live Chat Widget */}
    <div className="fixed bottom-20 md:bottom-24 left-4 md:left-6 z-50">
      <Button
        data-testid="live-chat-btn"
        size="sm"
        className="bg-primaryOrange hover:bg-accentOrange text-white shadow-2xl rounded-full px-4 py-5 md:px-6 md:py-6"
        onClick={() => toast.info('Live chat feature coming soon! Please call us at ' + clinicInfo.phone)}
      >
        <MessageCircle size={20} className="md:mr-2" />
        <span className="hidden md:inline">Chat with Us</span>
      </Button>
    </div>
  </>
  );
};
